import { orderContext } from '~/app/features/order-middleware/orderMiddleware';
import { ClaimType } from '~/utils/constants';
import { makeLoader, redirect } from '~/utils/routing';
import { shippingClaimContext } from '../shippingClaimMiddleware';

export const { loader, useLoaderData } = makeLoader(
  ({ context, params: { store = '' } }) => {
    const order = context.get(orderContext);
    const shippingProtectionClaim = context.get(shippingClaimContext);

    const override = order.shippingClaimReasonOverrides?.find(
      (o) => o.reason === shippingProtectionClaim.reason,
    );

    // the crew routes require a store slug, which is optional on these routes
    return override
      ? {
          ...override,
          to: `/${order.storeSlug}/order/${order.idFromPlatform}/${ClaimType.return.toLowerCase()}`,
        }
      : redirect(`/${store}`);
  },
);
